import { render, staticRenderFns } from "./event-card.vue?vue&type=template&id=6ace0f8d&scoped=true"
import script from "./event-card.vue?vue&type=script&lang=js"
export * from "./event-card.vue?vue&type=script&lang=js"
import style0 from "./event-card.vue?vue&type=style&index=0&id=6ace0f8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ace0f8d",
  null
  
)

export default component.exports